<template>

	<hit_login>

    <hit_dashboard>

			<div class="hit-panel hit-panel-danger">
				<div class="hit-panel-heading" >

					<div class="hit-row">

					<div class="hit-col-md-8">
						<div class="hit-form-group">
							<h4 class="hit-html-h4">{{ get_votes_length() }} {{ $tc('message.feedback', get_votes_length() ) }}</h4>
						</div>
					</div>

					<div class="hit-col-md-4">
						<div class="hit-form-group">
							<select v-model="filter" v-on:change="function(e){ set_filter(e.target.value, true) }" class="hit-form-control">
								<option value="*">*</option>
								<option v-for="boards_filter in $store.getters.boards_by_id" v-bind:value="boards_filter.ID">
									{{ boards_filter.name }}
								</option>
							</select>
						</div>
					</div>

					</div>

					<div class="hit-clearfix"></div>

				</div>
				<transition name="fade">

				<div class="hit-panel-body">
					<div class="hit-form-group">
					<div class="hit-input-group">
						<div class="hit-input-group-addon">

								<hit_icon :id="'user'" />

						</div>

						<input type="text" spellcheck="false" class="hit-form-control" v-on:keyup="set_search" v-bind:placeholder="$t('message.search')+': '+$t('message.username')">

					</div>
					</div>

					<div class="hit-form-group">
						<a href="#" v-on:click.prevent="set_search_time()" class="hit-btn hit-btn-xs" v-bind:class="[{ 'hit-btn-success': searchfilter.time }, { 'hit-btn-default': !searchfilter.time}]">
							<hit_icon :id="'calendar'"  />
					  </a>
						<select class="hit-form-control" v-on:change="set_time()" v-bind:key="searchfilter.time" v-if="searchfilter.time" v-model="date">
							<option value="today">{{ $t("message.today") }}</option>
							<option value="yesterday">{{ $t("message.yesterday") }}</option>
							<option value="month">{{ $t("message.thisMonth") }}</option>
							<option value="lastmonth">{{ $t("message.lastMonth") }}</option>
							<option value="year">{{ $t("message.thisYear") }}</option>
							<option value="lastyear">{{ $t("message.lastYear") }}</option>
						</select>
					</div>

					<div class="hit-form-group">
						<span v-for="(star) in [1,2,3,4,5]">
							<a href="#" v-bind:class="[{ 'hit-btn-success': searchfilter.average && search == star }, { 'hit-btn-default': !searchfilter.average}]" v-on:click.prevent="function(){ if(search == star){ search= ''; searchfilter = {average: false}; return false;}  searchfilter = {average: true}; search = star; }" class="hit-btn hit-btn-xs hit-btn-default" v-bind:title="$tc('message.star', star)"><hit_stars :stars="star" :notEmpty="true" :append="false" /></a>&nbsp;
						</span>
					</div>

				</div>
			</transition>

				<transition name="fade">

					<hit_table

						:actions="[false, function(value, row, column){ set_details(row) }, function(value, row, column){ set_filter(row) }, function(value, row, column){ set_details(row) }]"
						:titles='["#", $tc("message.username", 1), $tc("message.board", 1),  $tc("message.feedback", 1), $tc("message.date", 1)]'
						:icons='[false, "user", "group-chat", "star", "calendar", false, false]'
						:data='get_beautify( get_votes() )'

					/>

				</transition>

				<div class="hit-panel-footer" v-if="get_commulated()">
					<div class="hit-text-right">
						 &oslash; = <hit_stars class="hit-text-warning" :stars="get_commulated().stars"/> ({{ get_commulated().count }})
					</div>
				</div>

			</div>

    </hit_dashboard>

  </hit_login>

</template>

<script>

import feedback_detail from '@core/components/content/app/feedback/feedback_detail'
import md5 from 'js-md5'

export default{

  components: {feedback_detail},

  data: function () {
    return {
      board: {},
      votes: {},
      filter: '*',
      search: '',
      searchfilter: {'name': true, 'time': false, 'average': false},
      details: false,
      date: 'today'
    }
  },

  methods: {
    set_search_time () {
      this.searchfilter.time = !this.searchfilter.time

      if (this.searchfilter.time) { this.set_time() } else { this.search = '' }
    },
    set_time () {
      switch (this.date) {
        case 'today':
          var d = new Date()
          this.search = d.getFullYear() + '-' + this.get_nulls_before(d.getMonth() + 1) + '-' + this.get_nulls_before(d.getDate())
          break

        case 'month':
          var d = new Date()
          this.search = d.getFullYear() + '-' + this.get_nulls_before(d.getMonth() + 1) + '-'
          break

        case 'lastmonth':
          var d = new Date()
          d.setMonth(d.getMonth() - 1)
          this.search = d.getFullYear() + '-' + this.get_nulls_before(d.getMonth() + 1) + '-'
          break

        case 'year':
          var d = new Date()
          this.search = d.getFullYear() + '-'
          break

        case 'lastyear':
          var d = new Date()
          this.search = (d.getFullYear() - 1) + '-'
          break

        case 'yesterday':
          var d = new Date()
          d.setDate(d.getDate() - 1)
          this.search = d.getFullYear() + '-' + this.get_nulls_before(d.getMonth() + 1) + '-' + this.get_nulls_before(d.getDate())
          break
      }
    },
    get_nulls_before (d) {
      if (d < 10) { return '0' + d }
      return d
    },
    get_feedback: function (vote) {
      var my_class = this
      var r = false

      return r
    },

    get_details: function () {
      return this.details
    },

    set_details: function (index) {
      var data = this.get_votes()[index]
      this.$router.push({ name: 'feedback_details', params: {lang: this.$route.params.lang, boardID: md5('' + data.board), entryID: md5('' + data.ID) }})
      // this.details = this.get_votes()[index];
    },

    get_commulated: function () {
      var data = this.get_votes()

      if (data.length == 0) { return false }

      var stars = 0

      for (var i = 0; i < data.length; i++) {
        stars += data[i].average * 1
      }

      var r = { stars: Math.round((stars / data.length) * 100) / 100, count: data.length }
      r.stars_round = Math.round(r.stars)

      return r
    },

    set_filter: function (index, force) {
      if (typeof force !== 'undefined' && force) {
        this.filter = index
        return false
      }

      this.filter = this.get_votes()[(index)].board
    },

    set_search: function (e) {
      this.searchfilter.name = true
      this.searchfilter.average = false
      this.searchfilter.time = false
      this.search = e.target.value
    },

    get_filtered: function () {
      var data = JSON.parse(JSON.stringify(this.$store.getters.votes))
			
      if (typeof data === 'undefined' || data == false || !data.length) { return false }

      for (var i = 0; i < data.length; i++) {
        if (data[i].delete) { data[i].name = data[i].name + " (<i class='hit-glyphicon hit-glyphicon-bin'></i>)" }
      }

      if (this.filter == '*') { return data }

      var filter = []

      for (var i = 0; i < data.length; i++) {
        if (data[i].board == this.filter) {
          filter.push(data[i])
        }
      }

      return filter
    },

    get_search: function (data) {
      if (!data) {
        return []
      }

      if (this.search == '') { return data }

      var filter = []

      for (var i = 0; i < data.length; i++) {
        // NO SEARCH FILTER
        if (typeof this.searchfilter !== 'object') {
          for (var j = 0; j < Object.keys(data[i]).length; j++) {
            if (Object.values(data[i])[j].indexOf(this.search) != -1) { filter.push(data[i]) }
          }
        }

        // SEARCH FILTER
        else {
          for (var key in this.searchfilter) {
            var value = this.searchfilter[key]

            if (key == 'average' && value == true && Math.floor(data[i][key]) == this.search) {
              filter.push(data[i])
            } else if (key != 'average' && value == true && data[i][key].toString().toLowerCase().indexOf(this.search.toString().toLowerCase()) != -1) { filter.push(data[i]) }
          }
        }
      }

      return filter
    },

    get_beautify: function (data) {
      var ret = []

      if (!Object.keys(data).length) { return [] }

      var boards = this.$store.getters.boards_by_id

      data.forEach(function (k) {
        ret.push([ boards[k.board].ID + '-' + k.ID, k.name, boards[k.board].name, ['hit_stars', {stars: k.average, append: true}], k.time ])
      })

      return ret
    },

    get_votes: function () {
      return this.get_search(this.get_filtered())
    },
    get_votes_length: function () {
      return this.get_votes().length
    }

  },

  metaInfo: function () {
    return {
      title: this.$t('message.edit', {name: this.$tc('message.feedback', 2) })
    }
  },
  mounted () {
	 this.$store.dispatch('get_user_boards')
	 this.$store.dispatch('get_all_votes')
  }

}

</script>

<style scoped>

</style>
